import React, { useEffect, useState } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { GET_BILLS } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import { ORDER_STATUS } from '../../../data/constant';
import TableLayout from '../layout/TableLayout';
import FormLayout from '../layout/FormLayout';

export default function BillList() {

     const [bills, setBills] = useState([]);

     const tableHeaders = ['#', 'issue_date', 'doc_no', 'status', 'vendor', 'due_date', 'tax', 'amount', 'action'];

     const keys = ["bill_date", "bill_number", "status", "full_name", "due_date", "total_tax_amount", "net_amount", "btnEdit"];

     const btnData = {
          btnEdit: {
               name: "View", link: "/root/bill/view"
          }
     }

     useEffect(() => {
          getBills();
     }, []);

     const getBills = async (payload = {}) => {
          const res = await httpClient.post(GET_BILLS, payload);
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setBills(result.data);
               }
          }
     }

     const [formData, setFormData] = useState({
          formTitle: 'Search Customer',
          formFields: [
               { label: 'from_date', id: 'from_date', type: 'date', name: 'from_date', value: '', className: "col-md-2" },
               { label: 'to_date', id: 'to_date', type: 'date', name: 'to_date', value: '', className: "col-md-2" },
               { label: 'customer', id: 'customer', type: 'text', name: 'name', value: '', className: "col-md-3", placeholder: 'Enter name' },
               { label: 'number', id: 'number', type: 'text', name: 'number', value: '', className: "col-md-3", placeholder: 'Enter number' },
          ],
          formErrors: { from_date: '', to_date: '', name: '', number: '' },
     });

     const handleFieldChange = (fieldName, value) => {
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     const handleFieldBlur = () => { }

     const handleSubmit = (e) => {
          e.preventDefault();
          let post = {};
          const updatedFormFields = formData.formFields.map((field) => {
               post[field.name] = field.value;
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          getBills(post);
     }

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="bills" newButton="new" newButtonLink="root/bill/new" />
                    <div className="col-lg-12 grid-margin stretch-card">
                         <div className="card">
                              <div className="card-body">
                                   <FormLayout
                                        formTitle={formData.formTitle}
                                        formFields={formData.formFields}
                                        formErrors={formData.formErrors}
                                        onFieldChange={handleFieldChange}
                                        onFieldBlur={handleFieldBlur}
                                        onSubmit={handleSubmit}
                                        isModal
                                        search
                                   />
                                   <TableLayout
                                        headers={tableHeaders}
                                        keys={keys}
                                        tableData={bills}
                                        id="bill_id"
                                        btnData={btnData}
                                        statusKey="status"
                                        statusObject={ORDER_STATUS}
                                        numberKey={["net_amount", "total_tax_amount"]}
                                   />
                              </div>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
